import React, { useEffect, useState, useRef, createRef } from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
// import PropTypes from 'prop-types';
import Snackbar from '../../../Components/Snackbar/Snackbar'
import ErrorIcon from '@mui/icons-material/ErrorOutlineRounded';
import axios from 'axios'
import { genURL, gengetURLTEST } from '../../../_getjson';
import PopUpSelSaleRetReqRefSub from './PopUpSelSaleRetReqRefSub';
import FullScreenDialog from '../../FullScreendialogs/FullScreen'

export default function Invdebt(props) {
  const { parm } = props
  const [listitem, setListitem] = useState([])
  const [color, setColor] = useState("warning");
  const [icon, setIcon] = useState(ErrorIcon);
  const [messagealert, setMessagealert] = useState("");
  const [autoClose, setautoClose] = useState(3600);
  const [opensnackbar, setopensnackbar] = useState(false);
  const [openFullScreenDialog, setopenFullScreenDialog] = useState(false);
  const [dataMultipletax, setdataMultipletax] = useState("");
  const [tableselectrow, settableselectrow] = useState("");
  const [titleFullScreenDialog, settitleFullScreenDialog] = useState("");
  const [typeFullScreenDialog, settypeFullScreenDialog] = useState("");
  const DOCNO = useRef();
  const CREDITCODE = useRef();
  const Search = useRef();
  useEffect(() => {
    componentdidmount()
  }, [])
  const componentdidmount = () => {
    var url = "CSSELSALERETREQREF/GetALL?ARCODE=" + parm.ARCODE.trim()
    console.log(genURL(url));
    axios.get(genURL(url), { timeout: 3600 }).then(async (res) => {
      console.log(res.data);
      if (res.data.length > 0) {
        await setListitem(res.data)
      }
    }).finally(_ => {
      console.log("success");
    })
  }
  const Get_Data = () => {
    var url = "CSSELSALERETREQREF/GetALL?ARCODE=" + parm.ARCODE.trim() + "&DOCNOS=" + Search.current.value + "&ARNAME=" + Search.current.value
    axios.get(genURL(url), { timeout: 3600 }).then((res) => {
      console.log(res.data);
      setListitem(res.data)
    }).finally(_ => {

    })
  }
  const selectRowProp = {
    mode: 'radio', bgColor: '#2e6da469',
    clickToSelect: true,
    hideSelectColumn: true
  };
  function onRowSelect(row) {
    settableselectrow(row)
    DOCNO.current.value = row.DOCNO
    CREDITCODE.current.value = row.CREDITCODE
  }
  const onRowDoubleClick = (row) => {
    settableselectrow(row)
    DOCNO.current.value = row.DOCNO
    CREDITCODE.current.value = row.CREDITCODE
    openDialog("SelSaleRetReqRefSub")
  }
  const openDialog = (e) => {
    if (e === "SelSaleRetReqRefSub") {
      let Data = []
      Data = {
        ARCODE: parm.ARCODE,
        DOCNO: DOCNO.current.value
      }
      setdataMultipletax(Data)
      setopenFullScreenDialog(true)
      settitleFullScreenDialog("ค้นหาใบส่งของ/ใบกำกับภาษี-SelSaleRetReqRefSub")
      settypeFullScreenDialog(e)
    }
  }
  const ReturnData = (e) => {
    let resdatas = []
    resdatas.push(false)
    resdatas.push(e[1])
    resdatas.push(CREDITCODE.current.value)
    resdatas.push(tableselectrow)
    props.resdata(resdatas)
  }
  const CloseDialog = (e) => {
    setopenFullScreenDialog(e)
  }
  return (
    <div className='popup' style={{ 'z-index': '100' }} >
      <FullScreenDialog open={openFullScreenDialog} title={titleFullScreenDialog} closeDialog={e => CloseDialog(e)}>
        {typeFullScreenDialog === "SelSaleRetReqRefSub" ? <PopUpSelSaleRetReqRefSub closePopup={e => CloseDialog(e)} resdata={e => ReturnData(e)} parm={dataMultipletax} /> : null}
      </FullScreenDialog>
      <div className='popup_inner'>
        <div className="PopUpOtherDivH" align="left">
          <div className="PopUpOtherDivH1">
            <i className="fas fa-search"> </i>
          </div>
        </div>
        <div className="panel-body divTable" align="left">
          <div className="input-group width-grop">
            <input type="text" className="form-control" placeholder="ค้นหาเลขที่เอกสาร" onKeyUp={(e) => { if (e.key === "Enter") { Get_Data() } }} ref={Search} />
            <input type="hidden" className="form-control " ref={DOCNO} />
            <input type="hidden" className="form-control " ref={CREDITCODE} />
            <span className="input-group-addon txt-img icon">
              <i className="fas fa-search" onClick={Get_Data.bind()}></i>
            </span>
            <span className="input-group-addon txt-img icon">
              <i className="fas fa-sync-alt" onClick={() => { componentdidmount() }}></i>
            </span>
          </div>
          {/* </div> */}
          <BootstrapTable
            data={listitem}
            options={{
              onRowClick: onRowSelect,
              onRowDoubleClick: onRowDoubleClick,
              noDataText: "ไม่พบข้อมูล"
            }}
            selectRow={selectRowProp}
            height='650'
          >
            <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="30%" dataField='DOCNO' dataAlign="center" editable={false} isKey> เลขที่เอกสาร </TableHeaderColumn>
            <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="30%" dataField='DOCDATE' editable={false}> วันที่เอกสาร </TableHeaderColumn>
            <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="30%" dataField='SALENAME' editable={false}> พนักงานขาย </TableHeaderColumn>
            <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="10%" dataField='CREDITCODE' dataAlign="left" editable={false}> เครดิต </TableHeaderColumn>
            <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="30%" dataField='REMARK' dataAlign="left" editable={false}> หมายเหตุ </TableHeaderColumn>
            <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="10%" dataField='ARNAME' dataAlign="left" editable={false}> ลูกค้า </TableHeaderColumn>
            <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="10%" dataField='CURRNAME' dataAlign="left" editable={false}> สกุลเงิน </TableHeaderColumn>
            <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="15%" dataField='DEBTAMOUNT' dataAlign="right" editable={false}> จำนวนเงินทั้งสิ้น </TableHeaderColumn>
          </BootstrapTable>
          <Snackbar place="br"
            color={color}
            icon={icon}
            autoClose={autoClose}
            message={messagealert}
            open={opensnackbar}
            closeNotification={() => { setopensnackbar(false) }}
            close />

          <br></br>
          <button className="PUSDbtn" style={{ float: 'right' }} onClick={() => { openDialog("SelSaleRetReqRefSub") }}>ตกลง</button>
        </div>
      </div>
    </div >)
}

